import React from "react";
import ReactDOM from "react-dom/client";

import { ProductRecommendations } from "@app/scripts/react-product-recommendations/components/ProductRecommendations";

const ProductRecommendationsElem = class extends HTMLElement {
  static observedAttributes = [
    "columns-desktop",
    "columns-mobile",
    "disabled-mobile",
    "disabled-desktop",
    "product-id",
    "products-to-show",
  ];

  connectedCallback() {
    const props = {
      productId: this.getAttribute("product-id"),
      columnsDesktop: parseInt(this.getAttribute("columns-desktop") ?? "4"),
      columnsMobile: parseInt(this.getAttribute("columns-mobile") ?? "1"),
      disabledDesktop: this.getAttribute("disabled-desktop") === "true",
      disabledMobile: this.getAttribute("disabled-mobile") === "true",
      productsToShow: parseInt(this.getAttribute("products-to-show") ?? "4"),
    };

    const root = ReactDOM.createRoot(this);
    root.render(<ProductRecommendations {...props} />);
  }
};

customElements.define("product-recommendations", ProductRecommendationsElem);
